export default {
    //隐藏上传视频功能  暂时没研究。
    excludeKeys: [
        'insertVideo',
        'uploadVideo',
        'group-video'
    ]
}